<template>
  <div>
    <!-- add address -->
    <add-address :fromModal="false" :isNewAddress="isNewAddress" :address="addressToEditData" ></add-address>
    <el-divider></el-divider>
    <div class="form-row" v-if="user.addresses.length">
      <p>{{ $t('text.primary_address') }}</p>
      <address-item :item="user.primary_address" :small="false" @updateUserAddress="editAddress"></address-item>
      <hr />
      <address-item @updateUserAddress="editAddress"
        v-for="item in user.addresses"
        :small="true"
        :key="item.id"
        :item="item"
      ></address-item>
    </div>
    <div v-else>
      <empty-data
        :message="$t('empty.address')"
        icon="k-icon-home-outline"
        iconColor="#738290"
        textColor="#22223B"
      ></empty-data>
    </div>
  </div>
</template>
<script>
import { AddressItem, EmptyData, AddAddress } from "@/views/components";
import { mapState, mapActions, mapGetters } from "vuex";
import router from "../router";
import objectAddress from '@/model/address';
export default {
  name: "user-address",
  components: {
    AddAddress,
    AddressItem,
    EmptyData,
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  data() {
    return {
      addressToEditData: Object.assign({},objectAddress),
      isNewAddress : true,
    };
  },
  methods: {
    ...mapActions(["fetchAuthUser"]),
    editAddress(address){
      this.addressToEditData = address;
      this.isNewAddress = false;
    }
  },
  fetchAuthUser() {
    this.fetchAuthUser();
  },
  mounted() {
    if (!this.isAuthenticated) {
      router.push("/login");
    }
  },
};
</script>
